export const initialMachineMealy = {
    type: 'Mealy',
    nodes: {
        '0': {
            id: '0',
            name: '0',
            posx: 100,
            posy: 100,
            isStart: true,
            isFinal: false,
            type: 'NodeRect',
            width: 30,
            height: 30,
        }
    },
    transitions: {},
    nextStateId: 1,
    nextTransitionId: 0,
};
export const initialMachineDEA = {
    type: 'DEA',
    nodes: {
        '0': {
            id: '0',
            name: 'A',
            posx: 100,
            posy: 100,
            isStart: true,
            isFinal: false,
            type: 'NodeRect',
            width: 50,
            height: 50,
        }
    },
    alphabet: [],
    transitions: {},
    nextStateId: 1,
    nextTransitionId: 0,
};
export function machine_alphabet(machine) {
    if (machine.type === 'Mealy') {
        return machine.mealyModel.alphabet;
    }
    else {
        return machine.alphabet;
    }
}
